import { Flex, HStack, Text, Button, Link, Image } from '@chakra-ui/react';
import { SophieLogo, MainLogo } from '../../utils/Images';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const FormHeader = () => {
    const isLoggedIn = useSelector((state) => state?.Authlogin?.data?.token);
    return (<Flex
        as="nav"
        align="center"
        justify="space-between"
        px={{ base: 4, md: 12 }}
        py={4}
        bg="white"
    // boxShadow="sm"
    >
        <HStack spacing={3} as={NavLink} to="/">
            <Image src={SophieLogo} alt="Sophie Care" boxSize="40px" display={{ base: 'block', md: 'none' }} />
            <Image src={MainLogo} alt="Sophie Care" h="60px" w="200px" display={{ base: 'none', md: 'block' }} />
        </HStack>
        <HStack spacing={4}>
            {!isLoggedIn && <Link as={NavLink} to="/login" color="brand.500" fontWeight="semibold" fontSize={{ base: '12px !important', md: "16px" }}>
                Login
            </Link>}
            <Button
                colorScheme="brand"
                w={{ sm: '160px', md: 'auto' }}
                px={6}
                fontWeight="semibold"
                _hover={{ bg: "brand.600" }}
                fontSize={{ base: '12px !important', md: "16px" }}
            >
                Start free 30 days trail
            </Button>
        </HStack>
    </Flex>
    )
};

export default FormHeader; 